module.exports = __webpack_public_path__ + "static/media/single_event_timeline.5245d980.svg";